module.exports = "/assets/data/f29b8b331e50a4b5412e8c2f5488fa76-G20.data.json";